import { LazyTestLink } from 'modules/dev';
import { NegativeBalanceTermsOfServicesDialog } from 'domains/userSettings/screens/Settings/components/GeneralSettings/components/NegativeBalanceTermsOfServicesDialog';
import { TFADialog } from 'modules/tfa/components/TFADialog';
import { featureConfig } from 'modules/common/featureConfig';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { useAccount } from 'modules/account/hooks/useAccount';

import { Footer } from '../Footer';
import { FreemiumWelcomeDialog } from '../FreemiumWelcomeDialog';
import { Header } from '../Header';
import { MobileHeader } from '../MobileHeader';
import { SideBar } from '../SideBar';
import { StatusTransitionDialogContainer } from './components/StatusTransitionDialogContainer';
import { TopBanners } from '../TopBanners';
import { useDefaultLayoutStyles } from './DefaultLayoutStyles';
import { useTopBannersHeight } from '../TopBannersHeightProvider';
import { SettingsNavTabs } from '../SettingsNavTabs';
import { useDefaultLayout } from './hooks/useDefaultLayout';

export interface ILayoutProps {
  children?: React.ReactNode;
  hasError?: boolean;
}

export const DefaultLayout = ({ children, hasError = false }: ILayoutProps) => {
  const {
    isSettingsPage,
    isSwaggerUIPage,
  } = useDefaultLayout();

  const { group } = useAccount();

  const { topBannersHeight } = useTopBannersHeight();

  const { classes } = useDefaultLayoutStyles({
    hasGradient: hasError,
    topBannersHeight,
  });
  const isMobileSideBar = useIsSMDown();

  if (isSwaggerUIPage) {
    return <>{children}</>;
  }

  return (
    <>
      <TopBanners />
      <div className={classes.root}>
        <SideBar
          className={classes.sidebar}
          hasMenu
          isMobileSideBar={isMobileSideBar}
        />
        <div className={classes.main}>
          {!hasError && <Header className={classes.header} />}
          <MobileHeader className={classes.mobileHeader} />
          <>
            {isSettingsPage && group && <SettingsNavTabs />}
            {children}
          </>
          <Footer />
          <StatusTransitionDialogContainer />
          <TFADialog />
          <NegativeBalanceTermsOfServicesDialog />
          <FreemiumWelcomeDialog />
          {featureConfig.isDevUiEnabled && <LazyTestLink />}
        </div>
      </div>
    </>
  );
};
